module.exports = "table tr th {\r\n    white-space: nowrap;\r\n}\r\n\r\ntable tr td {\r\n    white-space: nowrap;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/clubprogram-reports/components/reconciliation-report/reconciliation-report.component.css
// module id = ./src/app/shared/clubprogram-reports/components/reconciliation-report/reconciliation-report.component.css
// module chunks = main